import { Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

export const StyledTypography = styled(Typography)(() => ({
  maxWidth: "100vw",
}));


